module.exports = __webpack_public_path__ + "static/img/主图.70a780f.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/match_result/figure/结果页/爱他人/谭义明/主图.png
// module id = Tmrf
// module chunks = 1